// size-7, size-8, size-9, size-10, size-11, size-12, size-14
// bg-green-500

export type Size =
  'default'
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12'
  | '14'
  | 'field';

export const sizeReference = 14;

export const Sizes = {
  'default': 14 / sizeReference,
  'xs': 4 / sizeReference,
  'sm': 6 / sizeReference,
  'md': 8 / sizeReference,
  'lg': 12 / sizeReference,
  'xl': 16 / sizeReference,
  '2xl': 20 / sizeReference,
  '3xl': 24 / sizeReference,
  '4xl': 32 / sizeReference,
  '5xl': 40 / sizeReference,
  '6xl': 48 / sizeReference,
  '7xl': 56 / sizeReference,
  '8xl': 64 / sizeReference,
  '9xl': 96 / sizeReference,
  'field': 35.5 / sizeReference,
};